import { ApolloClient, ApolloProvider } from '@apollo/client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import PurchaseOrderRequestPage from './components/pages/purchaseOrder/PurchaseOrderRequestPage';
import { initializeTitleState } from './components/pages/title-state';
import { createClientConfig } from './utils/apollo-client';

function createClient(token: string) {
    return new ApolloClient(
        createClientConfig(false, {
            headers: {
                'X-PO-Token': token,
            },
        })
    );
}

type PoNumberRequestPageModule = {
    options: {
        token: string;
        branch: string;
        siteTitle: string;
    };
};

export default function poNumberRequestPage({
    options: { token, branch, siteTitle },
}: PoNumberRequestPageModule) {
    const element = document.getElementById('po-number-request-root');

    if (!element) {
        return;
    }

    initializeTitleState({ branch, siteTitle });

    const client = createClient(token);

    const root = createRoot(element);
    root.render(
        <StrictMode>
            <ApolloProvider client={client}>
                <PurchaseOrderRequestPage token={token} />
            </ApolloProvider>
        </StrictMode>
    );
}
